// Just adding this code to avoid using querySelectorAll for each slider and to prevent iterating through them every time when snippet added,
// as the code also handles the case where there may be multiple sliders on the page.
// The JS logic is attached to each snippet individually due to task constraints, so we cannot implement this globally.

(function () {
  if (!Splide) return;
  const scriptElement = document.currentScript;
  const currentSectionId = scriptElement?.dataset?.sectionInitiator;
  if (!currentSectionId) return;

  let splides = [];
  const getSliderAndConfig = (currentSectionId) => {
    const section = document.getElementById(
      `shopify-section-${currentSectionId}`
    );

    const sectionSliders = Array.from(section.querySelectorAll(".splide"));
    if (!sectionSliders.length) return;

    const sliderConfigs = sectionSliders.map(el => JSON.parse(el.getAttribute("data-slider-config"))) 
   
    return { sectionSliders, sliderConfigs };
  };
  const initSlider = (sectionSliders, sliderConfigs) => {
    sectionSliders.forEach((el, index) => {
      if(splides[index] && typeof splides[index].destroy === 'function') {
        splides[index].destroy();
      }
      
      if(el.offsetParent !== null) {
        splides[index] = new Splide(el, sliderConfigs[index]);
        splides[index].mount();
      }
    })
  };

  const initBySectionId = (currentSectionId) => {
    const { sectionSliders, sliderConfigs } =
      getSliderAndConfig(currentSectionId);
    if (!sectionSliders.length || !sliderConfigs) return;
    initSlider(sectionSliders, sliderConfigs);
  };

  window.addEventListener('load', () => initBySectionId(currentSectionId))
  


  document.addEventListener('filter-change', () => {
    initBySectionId(currentSectionId)
  })

  const handleTabSwitch = () => {
    if(splides.length) {
      splides.forEach(el => {
        if(el && typeof el.destroy === 'function') {
          el.destroy()
        }
      })
      splides = []
    }
    
    setTimeout(() => {
      initBySectionId(currentSectionId)
    }, 100)
  }

  document.addEventListener('click', (e) => {
    if(e.target.classList.contains('bestsellers__subcategory-button') || e.target.classList.contains('tabs-nav__item--bestseller') || e.target.parentElement.classList.contains('tabs-nav__item--bestseller')) {
      handleTabSwitch();
    }
  })

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
        const target = mutation.target
        if (target.classList && target.classList.contains('product-list')) {
          handleTabSwitch()
        }
      }
    })
  })

  const section = document.getElementById(`shopify-section-${currentSectionId}`)
  if (section) {
    observer.observe(section, {
      attributes: true,
      subtree: true,
      attributeFilter: ['hidden']
    })
  }


  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", (e) => {
      if(splides.length) {
        splides.forEach(el => {
          el.destroy()
        })
        splides = []
        initBySectionId(e.detail.sectionId)
      }
    });
    document.addEventListener("shopify:block:select", (e) => {
      const currentBlock = document.querySelector(`[data-id=${e.detail.blockId}`)
      const currentIndex = currentBlock?.dataset?.index
      if(splides.length && currentIndex) {
        const index = Number(currentIndex)
        splides[index].go(index)
      }
    })
  }
})();
